import { render } from "./LocationsDashboardComponent.vue?vue&type=template&id=bf6a67f0&scoped=true"
import script from "./LocationsDashboardComponent.vue?vue&type=script&lang=js"
export * from "./LocationsDashboardComponent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-bf6a67f0"

export default script